<template>
    <div class="wrapt">
        <div style="position:relative">
            <div class="ghSty">
                <img class="wpImg" src="./image/bg.png">
                <div class="zmSty">
                    <div class="lnSty">{{companyTypeName}}-故障报修</div>
                    <div class="fgSty">用户至上是我们运维服务的永恒主题</div>
                </div>
            </div>
            <div style="background-color:#CBE5FF;position:absolute;top:128px;height:40px;width:80%;margin:0 10%;border-radius:20px"></div>
            <div class="atSty">
                <div class="adSty">
                    <div>
                        <van-form @submit="submit">
                            <div id="" v-if="JSON.stringify(emergencyContact)!={}" style="font-size:14px;text-align: center;padding: 5px 0;">
                                紧急联系人：{{emergencyContact.name}} &nbsp;&nbsp;&nbsp; {{emergencyContact.tel}}
                            </div>
                            <div id="" v-else style="font-size:14px;text-align: center;padding: 5px 0;">
                                暂无紧急联系人
                            </div>
                            <div class="alSty">
                                <div class="blkb">
                                    <div class="txtc"></div>
                                    <div>
                                        <div class="txtd">报修人电话</div>
                                    </div>
                                    <div :class="{blkc:true,blkc3:msShow}">
                                        <van-field v-model="datam.tel" type="tel" @input="showSty" :rules="[
											 {validator: mtPhone, message: '请输入报修人电话'},
											 {validator: checkPhone, message: '电话格式错误'}]" placeholder="请输入报修人电话" />
                                    </div>
                                </div>
                            </div>
                            <div class="alSty">
                                <div class="blkb">
                                    <div class="txtc"></div>
                                    <div>
                                        <div class="txtd">报修人房间号</div>
                                    </div>
                                    <div class="blkc">
                                        <van-field v-model="datam.room" placeholder="请输入报修人房间号" rows="1" autosize :rules="[{ required: true, message: '请输入报修人房间号' }]" type="textarea" />
                                    </div>
                                </div>
                            </div>
                            <div class="alSty">
                                <div class="blkb">
                                    <div class="txtc"></div>
                                    <div>
                                        <div class="txtd">维护类型</div>
                                    </div>
                                    <div class="blkc" @click="etSelect" v-if="columns.length >0">
                                        <!-- <div class="txte" :style ="'color:'+(eType=='请选择'?'red':'')">{{eType}}</div> -->
                                        <van-field v-model="eType" placeholder="请选择维护类型" readonly rows="1" autosize :rules="[{ required: true, message: '请选择维护类型' }]" type="textarea" />
                                        <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img>
                                        </div>
                                    </div>
                                    <div class="blkc" v-else>
                                        <!-- <div class="txte" :style ="'color:'+(eType=='请选择'?'red':'')">{{eType}}</div> -->
                                        <van-field v-model="eType" placeholder="暂无维护类型，请从管理端配置" readonly rows="1" autosize :rules="[{ required: true, message: '请选择维护类型' }]" type="textarea" />
                                        <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="alSty">
								<div class="blkb">
									<div class="txtc"></div>
									<div>
										<div class="txtd">故障描述</div>
									</div>
									<div class="blkcm">
										<van-field v-model="datam.supportDescribe" placeholder="请输入故障描述" rows="3"
											autosize :rules="[{ required: true, message: '请输入故障描述' }]"
											type="textarea" />
									</div>
								</div>
							</div> -->
                            <div class="alSty">
                                <div class="blkbt">
                                    <div class="txtc"></div>
                                    <div>
                                        <div class="txtd1">维护人员</div>
                                    </div>
                                    <div class="blkc1" v-if="tData">
                                        <div class="utSty">
                                            <div style="display:flex;color:#fff;">
                                                <div class="kySty">
                                                    {{tData.name}}
                                                </div>
                                                <div class="hjSty">
                                                    <!-- {{companyTypeName}} -->
                                                    淮工深蓝-运维工程师
                                                </div>
                                            </div>
                                            <div class="fhSty">
                                                {{tData.tel}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="blkc1" v-else>
                                        <div class="utSty">
                                            <!-- <div style="display:flex;color:#fff;"> -->
                                            <div class="kySty" style="text-align:center">
                                                暂无维护工程师
                                            </div>
                                            <!-- <div class="hjSty"> -->
                                            <!-- {{companyTypeName}} -->
                                            <!-- 淮工深蓝-运维工程师 -->
                                            <!-- </div> -->
                                            <!-- </div> -->
                                            <div class="fhSty">
                                                <!-- {{tData.tel}} -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kmSty">
                                <van-button round block type="info" native-type="submit">提交</van-button>
                                <!-- <div class="bgSty" @click="submit">
									提交工单
								</div> -->
                            </div>
                        </van-form>

                    </div>
                </div>
            </div>
        </div>
        <!-- 选择维护类型 -->
        <van-popup v-show="showPop" :lazy-render='false' round position="bottom" :style="{ height: '40%' }">
            <div id="">

            </div>
            <div id="">
                <!-- <van-picker ref="picker" id="pickers" title="标题"  @confirm="onConfirm" /> -->
                <van-picker ref="van_picker" :columns="columns" @cancel="showPop = false" @change="onChange" @confirm="onConfirm" show-toolbar :columns-field-names="customFieldName" />
            </div>

            <!-- <div style="display:flex;align-items:center;justify-content:center">
				<div class="submit" @click="onConfirm">确定提交</div>
			</div> -->
        </van-popup>
        <div style="width:100%;height:100%" v-if="eShow1">
            <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                <div class="dialogs2">
                    <div class="digtxt1">维护类型</div>
                    <div style="display:flex;">
                        <div class="imgblk" @click="close"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                        <!-- <div class="imghj" style="flex:1;">
								<div class="rectSty">
									<div :class="className"></div>
									<div :class="className1">
										<div class="tRect"></div>
									</div>
								</div>
							</div> -->
                        <div style="flex:1">
                            <div class="digtxt2" @click="selectd(index,item)" v-for="(item,index) in dItem" :key="index">
                                <div :style="{borderColor:color1}" :class="{active2:(current2==index),nbtn:true,nbtn1:true}">{{item.value}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display:flex;align-items:center;justify-content:center">
                    <div class="submit" @click="submit2">提交</div>
                </div>
            </div>
        </div>
        <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
    </div>
</template>
<script>
import customToast from "@/components/toast.vue";
import { getToken } from "@/util/auth.js";
import { mapActions } from "vuex";
export default {
    components: {
        customToast,
    },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            index: "",
            msShow: false,
            showPop: false,
            datam: {
                companyId: "",
                handleId: "", //处理人Id
                handleName: "", //处理人姓名
                handleTel: "", //处理人电话
                room: "", //房间
                supportDescribe: "", //故障描述
                supportGroup: "", //报修组别(1纪检内网2德园)
                supportType: "", //一级维护类型(0信息化)
                supportTypeItem: "", //二级维护类型
                tel: "", //报修人电话
            },
            companyTypeName: undefined,
            emergencyContact: {},
            group: undefined,
            dataha: [],
            color1: "",
            eShow1: false,
            val2: "信息化",
            current2: "0",
            disShow: false,
            eType: "",
            tData: "",
            dItem: [
                {
                    id: 0,
                    value: "德园",
                },
                {
                    id: 1,
                    value: "纪检内网",
                },
            ],
            columns: [],
            customFieldName: {
                text: "content",
                children: "list",
            },
            // columns: [{
            // 	id: 0,
            // 	text: '信息化',
            // 	children: [{
            // 		"configId": 1,
            // 		"supportType": 0,
            // 		"text": "测试类型-配置",
            // 		"createTime": "2021-07-09T09:41:43.000+0800",
            // 		"delFlag": 0
            // 	}, {
            // 		"configId": 4,
            // 		"supportType": 0,
            // 		"text": "fds g地方",
            // 		"createTime": "2021-07-12T14:34:29.000+0800",
            // 		"delFlag": 0
            // 	}],
            // }],
        };
    },
    created() {
        // 1纪检2德园
        // var dacao = window.location.href.split("=")[2]
        // console.log(window.location.href)
        // console.log(this.$route.query.id)
        if (this.$route.query.id == 1) {
            this.companyTypeName = "纪检内网";
            this.datam.companyId = 12;
        } else if (this.$route.query.id == 2) {
            this.companyTypeName = "德园";
            this.datam.companyId = 12;
        }
        this.group = this.$route.query.id;
        this.datam.supportGroup = this.$route.query.id;
        // 紧急联系人
        const data = {
            group: 0,
        };
        this.$api
            .get("/app/dySupportRecord/getDyWorkPersonInfo", {
                params: data,
            })
            .then((res) => {
                this.emergencyContact =
                    res.data.data == null ? {} : res.data.data;
            });
        //根据id获取对应的工程师
        const dataa = {
            group: this.$route.query.id,
        };
        this.$api
            .get("/app/dySupportRecord/getDyWorkPersonInfo", {
                params: dataa,
            })
            .then((res) => {
                // console.log(JSON.stringify(res))
                this.tData = res.data.data;
                this.datam.handleId = res.data.data.engineerId;
                this.datam.handleName = res.data.data.name;
                this.datam.handleTel = res.data.data.tel;
                this.index = 0;
                this.tData.group = "工作人员";
                this.val2 = "信息化";
                this.current2 = 0;
            });
        //查询报修类型配置(0信息化1纪检内网)

        const repairType = {
            supportType: this.$route.query.id == 1 ? "1" : "0",
        };
        this.$api
            .get("/app/dySupportRecord/getRepairTypeConfigDetailInfo", {
                params: repairType,
            })
            .then((res) => {
                // console.log(JSON.stringify(res));
                if (res.data.data) {
                    const cao = res.data.data;
                    for (var i = 0; i < cao.length; i++) {
                        cao[i].text = cao[i].supportTypeName;
                        cao[i].id = cao[i].supportType;
                        cao[i].children = cao[i].list;
                        for (var j = 0; j < cao[i].children.length; j++) {
                            cao[i].children[j].text =
                                cao[i].children[j].content;
                        }
                    }
                    this.columns = cao;
                } else {
                    this.columns = [];
                }
                // this.dataha = res.data.data
                // const columnsa = [{
                // 	id: 0,
                // 	text: '信息化',
                // 	children: [{
                // 		"configId": 1,
                // 		"supportType": 0,
                // 		"text": "测试类型-配置",
                // 		"createTime": "2021-07-09T09:41:43.000+0800",
                // 		"delFlag": 0
                // 	}, {
                // 		"configId": 4,
                // 		"supportType": 0,
                // 		"text": "fds g地方",
                // 		"createTime": "2021-07-12T14:34:29.000+0800",
                // 		"delFlag": 0
                // 	}],
                // }];
                // this.columns = columnsa
                // this.$refs.van_picker.setColumnValues(d)
                // this.columns[0].children = res.data.data
                // let timeLast = this.selectComponent('#pickers')
                // timeLast.setColumnValue(1, this.dataha)
                // this.$refs.picker.value.setColumnValues(1,this.dataha)
            });
    },
    mounted() {},
    watch: {},
    methods: {
        showSty() {
            this.msShow = false;
        },
        mtPhone(value, rule) {
            if (!value) {
                this.msShow = false;
                return false;
            } else {
                this.msShow = false;
            }
        },
        checkPhone(value, rule) {
            if (!/^1[34578]\d{9}$/.test(value)) {
                this.msShow = true;
                return false;
            } else {
                this.msShow = false;
            }
        },
        close() {
            this.eShow1 = false;
        },
        selectd(index, val) {
            this.current2 = index;
            this.index = index;
            this.val2 = val.value;
        },
        onChange(picker, values) {
            //在change 第一列的时候，动态更改第二列的数据
            //setColumnValues是vant自带的实例方法
            //第一个参数是列数，从0开始；第二个参数是第二列应该显示的数据
            // picker.setColumnValues(1, [{
            // 	"configId": 1,
            // 	"supportType": 0,
            // 	"text": "测试类型-配置",
            // 	"createTime": "2021-07-09T09:41:43.000+0800",
            // 	"delFlag": 0
            // }, {
            // 	"configId": 4,
            // 	"supportType": 0,
            // 	"text": "fds g地方",
            // 	"createTime": "2021-07-12T14:34:29.000+0800",
            // 	"delFlag": 0
            // }]);
        },
        // 选择维护类型
        onConfirm(data, index) {
            // console.log(JSON.stringify(data) + '====' + index)
            this.eType = data[0] + " " + data[1];
            const w = index.toString();
            const d = w.split(",");
            this.datam.supportType = this.columns[d[0]].id;
            this.datam.supportTypeItem =
                this.columns[d[0]].children[d[1]].configId;
            this.showPop = false;
            // console.log(JSON.stringify(picker.getValues))
            // picker.setColumnValues(0, this.dataha)
        },
        etSelect() {
            // this.eShow1 = true;
            this.showPop = true;
        },
        reback() {
            this.eShow1 = false;
        },
        submit() {
            // this.datam.supportType = this.index;
            // console.log(this.datam.handleId);
            if (this.tData) {
                this.$api
                    .post(
                        "/app/dySupportRecord/dySupportRecordReport",
                        this.datam
                    )
                    .then((res) => {
                        if (res.data.code == "0000") {
                            // this.$toasts("提交成功");
                            this.toastRow = {
                                selId: 4,
                                title: "提交成功",
                                text: "您已成功提交报修",
                            };
                            this.toastFlag = true;
                            setTimeout(() => {
                                this.toastFlag = false;
                            }, 1500);
                            this.datam = {
                                handleName: "",
                                handleTel: "", //处理人电话
                                room: "",
                                supportDescribe: "",
                                supportType: "",
                                tel: "",
                            };
                            this.datam.handleId = this.tData.engineerId;
                            this.datam.handleName = this.tData.name;
                            this.datam.handleTel = this.tData.tel;
                            this.datam.supportGroup = this.$route.query.id;
                            this.datam.companyId = 12;
                            this.eType = "";
                            this.index = 0;
                            this.val2 = "信息化";
                            this.current2 = 0;
                        }
                    });
            } else {
                // this.$toastf("暂无维护人员");
                this.toastRow = {
                    selId: 5,
                    title: "暂无维护人员",
                    text: "暂无维护人员",
                };
                this.toastFlag = true;
                setTimeout(() => {
                    this.toastFlag = false;
                }, 1500);
            }
        },
        submit2() {
            this.eShow1 = false;
            this.eType = this.val2;
            this.datam.supportType = this.index;
            // this.gethData()
        },
        gethData() {
            // if (this.index == 0) {
            //     let data = {
            //         companyId: 12,
            //     };
            //     this.$api
            //         .get("/app/dySupportRecord/getDyEnginnerInfoByName", {
            //             params: data,
            //         })
            //         .then((res) => {
            //             this.tData = res.data.data[0];
            //             this.tData.group = "淮工深蓝-工程师";
            //             this.datam.handleId = this.tData.personId;
            //             this.datam.handleName = this.tData.name;
            //             this.datam.handleTel = this.tData.tel;
            //             this.index = 0;
            //             this.val2 = "信息化";
            //             this.current2 = 0;
            //         });
            // } else {
            let data = {
                group: this.group,
            };
            this.$api
                .get("/app/dySupportRecord/getDyWorkPersonInfo", {
                    params: data,
                })
                .then((res) => {
                    // console.log(JSON.stringify(res))
                    this.tData = res.data.data == null ? {} : res.data.data;
                    this.datam.handleId =
                        res.data.data == null
                            ? undefined
                            : res.data.data.engineerId;
                    this.datam.handleName = this.tData.name;
                    this.datam.handleTel = this.tData.tel;
                    this.index = 0;
                    this.tData.group = "工作人员";
                    this.val2 = "信息化";
                    this.current2 = 0;
                });
            // }
        },
    },
    beforeDestroy() {},
};
</script>
<style>
::v-deep .van-dialog {
    width: 75% !important;
}
::v-deep .van-field__value {
    overflow: auto;
}
::v-deep .van-field {
    max-height: 200px;
    height: auto !important;
}
.digtxt3 {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    /* margin-bottom: 54px; */
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.wrapt {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 3000;
    overflow: hidden;
    background: #e9eef2;
}

.alSty {
    background: #fff;
    padding: 0 21px;
}

.imga {
    float: left;
    width: 22px;
    height: 22px;
}

.blkb {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}

.blkbt {
    position: relative;
    margin: 0 auto;
    padding: 8px 0px;
    background: #fff;
}

.txtc {
    position: absolute;
    top: 10px;
    left: 0;
    width: 4px;
    height: 13px;
    background: #1aaeff;
}

.imgblk {
    display: flex;
    position: absolute;
    top: 8px;
    right: 12px;
    width: 12px;
    height: 12px;
}

.imgtlk {
    flex: 1;
    width: 100%;
    height: 100%;
}

.txte {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}

.blkf {
    flex: 0 0 22px;
}

.txtd {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
}

.txtd1 {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    padding: 0 13px;
}

.blkc {
    display: flex;
    height: 26px;
    margin-top: 8px;
}

.blkcm {
    display: flex;
    height: 70px;
    margin-top: 8px;
}

.blkcm .van-field__body {
    display: flex;
    height: 70px;
    margin-top: 8px;
}

/* .blkcm .van-field{
		border:1px solid #ccc;
		padding:0 10px;
	} */
.blkc3 {
    display: flex;
    height: 46px;
    margin-top: 8px;
}

.blkc1 {
    display: flex;
    height: 62px;
    margin-top: 8px;
}

.van-cell {
    padding-top: 0;
    padding-bottom: 0;
    padding: 0;
}

.van-field__body {
    height: 22px;
}

.mtblk {
    width: 100%;
    height: 667px;
}

.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 490px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs2 {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0 15px;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 100px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs1 {
    height: 179px;
}

.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}

.digtxt1 {
    width: 200px;
    height: 30px;
    font-size: 22px;
    margin: 26px auto;
    font-weight: 800;
    text-align: center;
    color: #003cff;
    line-height: 30px;
}

.digtxt2 {
    width: 200px;
    height: 56px;
    margin: 0px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}

.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}

.msubmit {
    flex: 0 0 211px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    margin-top: 20px;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
}

.utSty {
    width: 100%;
    height: 58px;
    opacity: 1;
    background: linear-gradient(45deg, #5fbef6 1%, #0099ff 97%);
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    padding: 8px 19px;
    box-sizing: border-box;
}

.mtblk {
    width: 100%;
    height: 667px;
}

.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 179px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 249px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}

.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}

.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}

.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}

.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    /* margin-left: 20px; */
}

.submit {
    flex: 0 0 211px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    margin-top: 20px;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
}

.mtblk {
    width: 100%;
    height: 100%;
}

.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 490px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs2 {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0 15px;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 300px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}

.dialogs1 {
    height: 179px;
}

.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}

.digtxt1 {
    width: 200px;
    height: 30px;
    font-size: 22px;
    margin: 26px auto;
    font-weight: 800;
    text-align: center;
    color: #003cff;
    line-height: 30px;
}

.digtxt2 {
    width: 200px;
    height: 56px;
    margin: 0px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}

.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}

.nbtn {
    width: 211px;
    height: 42px;
    background: #eeeeee;
    border-radius: 21px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 42px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
}

.nbtn1 {
    width: 211px;
}

.active1 {
    background: #ffffff;
    border: 2px solid #008cff;
    border-radius: 21px;
    color: #008cff;
}

.active2 {
    width: 211px;
    height: 42px;
    background: #ffffff;
    border: 2px solid #0bbcb2;
    border-radius: 21px;
}

.ghSty {
    width: 100%;
    height: 225px;
}

.wpImg {
    width: 100%;
    height: 225px;
}

.zmSty {
    display: flex;
    flex-direction: column;
    height: 100px;
    position: absolute;
    top: 60px;
    left: 33px;
}

.lnSty {
    height: 22px;
    font-size: 22px;
    color: #ffffff;
    line-height: 26px;
}

.fgSty {
    margin-top: 10px;
    width: 303px;
    height: 13px;
    font-size: 13px;
    text-align: left;
    color: #cae5ff;
    line-height: 16px;
}

.atSty {
    position: absolute;
    top: 140px;
    left: 0;
    width: 100%;
    height: 510px;
}

.adSty {
    width: 340px;
    /* height: 510px; */
    padding: 15px 18px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #fff;
    border-radius: 13px;
    box-shadow: 0px 4px 29px 0px rgba(32, 123, 242, 0.08);
}

.kmSty {
    width: 100%;
    height: 100%;
    margin-top: 15px;
}

.bgSty {
    font-size: 16px;
    color: #fff;
    border-radius: 17px;
    width: 289px;
    margin: 0 auto;
    text-align: center;
    height: 45px;
    line-height: 45px;
    opacity: 1;
    background: linear-gradient(2deg, #236eeb 2%, #1c8cfa 98%);
}

.kySty {
    flex: 0 0 90px;
    font-size: 16px;
}

.hjSty {
    flex: 1;
    font-size: 10px;
    margin-top: 3px;
}

.fhSty {
    font-size: 12px;
    color: #fff;
    margin-top: 10px;
}
</style>
